<template>
    <div>

        <b-modal id="create-or-update-visa" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <employee-visa-create-or-update v-model="visa" :errors="errors"></employee-visa-create-or-update>
            <template #modal-footer><v-executer  :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>
            
        <v-table    ref="table"
                    with-items
                    search
                    :items="value"
                    up-class="px-1 pb-1"
                    :add-callback="createNew"
                    :buttons="buttons"
                    name="employee-visa"
                    overlay-class="pb-0"
                    :fields="fields"></v-table>
        

    </div>
</template>

<script>
import EmployeeVisaCreateOrUpdate from './EmployeeVisaCreateOrUpdate.vue'
import randomatic from 'randomatic'
import moment from 'moment'

export default {
    components:{
        EmployeeVisaCreateOrUpdate,
    },
    props:{
        value:Array,
        id:[String,Number]
    },
    data(){
        return{
            fields:[
                {name:"Ülke",key:"CountryName",thClass:"w-25"},
                {name:"Vize",key:"VisaTypeName",thClass:"w-25"},
                {name:"Başlangıç Tarihi",key:"StartDateVisual",thClass:"w-25"},
                {name:"Bitiş Tarihi",key:"EndDateVisual",thClass:"w-25"},
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            visa:{
                Id:null,
                CountryId:null,
                CountryName:null,
                VisaTypeId:null,
                VisaTypeName:null,
                StartDate:null,
                StartDateVisual:null,
                EndDate:null,
                EndDateVisual:null,
                EmployeeId:null,
            },
            errors:{},
            editing:false,
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.visa.Id = null
            this.visa.CountryId = null
            this.visa.CountryName = null
            this.visa.VisaTypeId = null
            this.visa.VisaTypeName = null
            this.visa.StartDate = null
            this.visa.StartDateVisual = null
            this.visa.EndDate = null
            this.visa.EndDateVisual = null
            this.visa.EmployeeId = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update-visa')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.visa.Id = item.Id
            this.visa.CountryId = item.CountryId
            this.visa.CountryName = item.CountryName
            this.visa.VisaTypeId = item.VisaTypeId
            this.visa.VisaTypeName = item.VisaTypeName
            this.visa.StartDate = item.StartDate
            this.visa.StartDateVisaual = item.StartDateVisaual
            this.visa.EndDate = item.EndDate
            this.visa.EndDateVisual = item.EndDateVisual
            this.visa.EmployeeId = null
            this.$showModal('create-or-update-visa')
        },
        validation(){
            let count = 0
            if(this.$isNullOrEmpty(this.visa.CountryId)){
                this.$set(this.errors,'CountryId','Ülke alanı zorunludur.')
                count ++
            }
            if(this.$isNullOrEmpty(this.visa.VisaTypeId)){
                this.$set(this.errors,'VisaTypeId','Vize alanı zorunludur.')
                count ++
            }
            if(this.$isNullOrEmpty(this.visa.StartDate)){
                this.$set(this.errors,'StartDate','Başlangıç tarihi alanı zorunludur.')
                count ++
            }
            if(this.$isNullOrEmpty(this.visa.EndDate)){
                this.$set(this.errors,'EndDate','Bitiş tarihi alanı zorunludur.')
                count ++
            }
            return count > 0 ? false : true
        },
        createOrUpdate(){
            if(this.validation()){
                if(this.visa.Id){
                    let item = this.value.find(r=> r.Id == this.visa.Id)
                    this.$set(item,"CountryId",this.visa.CountryId)
                    this.$set(item,"CountryName",this.visa.CountryName)
                    this.$set(item,"VisaTypeId",this.visa.VisaTypeId)
                    this.$set(item,"VisaTypeName",this.visa.VisaTypeName)
                    this.$set(item,"StartDate",this.visa.StartDate)
                    this.$set(item,"StartDateVisual",moment(this.visa.StartDate).locale("tr").format('L'))
                    this.$set(item,"EndDate",this.visa.EndDate)
                    this.$set(item,"EndDateVisual",moment(this.visa.EndDate).locale("tr").format('L'))
                    this.$set(item,"EmployeeId",this.visa.EmployeeId)
                    this.$set(item,"Unsaved",true)
                }else{
                    this.value.push({
                        Id:randomatic("A0",10),
                        CountryId:this.visa.CountryId,
                        CountryName:this.visa.CountryName,
                        VisaTypeId:this.visa.VisaTypeId,
                        VisaTypeName:this.visa.VisaTypeName,
                        StartDate:this.visa.StartDate,
                        StartDateVisual:moment(this.visa.StartDate).locale("tr").format('L'),
                        EndDate:this.visa.EndDate,
                        EndDateVisual:moment(this.visa.EndDate).locale("tr").format('L'),
                        EmployeeId:this.id,
                        Unsaved:true
                    })
                }
                this.$hideModal('create-or-update-visa')
            }
        },
        delete(item,key,index){
            this.$confirm("Silmek istediğinize emin misiniz?",`Bu işlem ${item.CountryName} ülkesine ait vize bilgisini ve geri alınamaz.`).then(res=>{
                if(res){
                    this.$delete(this.value,index)
                }
            })
        },
    }
}
</script>

<style>

</style>